// =============================================================================
// HEADER — mobile navigation toggle
// =============================================================================

const menuToggle = document.querySelector('.header__menu-toggle');
const mobileNav  = document.getElementById('mobile-nav');

if (menuToggle && mobileNav) {
  menuToggle.addEventListener('click', () => {
    const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';

    menuToggle.setAttribute('aria-expanded', String(!isExpanded));
    menuToggle.setAttribute(
      'aria-label',
      isExpanded ? 'Abrir menu de navegação' : 'Fechar menu de navegação',
    );
    mobileNav.hidden = isExpanded;
  });

  // Close on any nav link click
  mobileNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Abrir menu de navegação');
      mobileNav.hidden = true;
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !mobileNav.hidden) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Abrir menu de navegação');
      mobileNav.hidden = true;
      menuToggle.focus();
    }
  });
}
